<div>
    <h5 *ngIf="buildname">{{buildname.buildingName}}</h5>
    <button class="closeButton"  matDialogClose>
        <span>x</span>
    </button>
</div>

<ng-container>
   
    <div class="cctv__popupvideo">
        <div class="cctv-frame">
            <iframe id="iframe-id" style=" width: 100%; height: 100%; " [src]="cctvURL" title="Iframe Example"></iframe>
        </div>
    </div>
    <!-- <div>
        <button class="create">add carema</button>
    </div> -->
    <form [formGroup]="channelfrom">
    <div class="ibox-title report_flexweb">
       
        <div>
           <label class="channelname">Channel Name : <input type="text" placeholder="Enter channel name"   formControlName="Channelname" class="channelflied" ></label>
        </div>
        
        <div class="icon_flex">
            <div>
                <button class="create" (click)="save()">Add Camera </button>
            </div>
        </div>
   
    </div>
</form>
</ng-container>
<!--========= loader =======-->
<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner> -->